import './reneebistro/style';
import FormStructure from './reneebistro/form_structure';

export default FormStructure;